import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.CREATE_TAG_REQUEST,
    SUCCESS: types.CREATE_TAG_SUCCESS,
    FAILURE: types.CREATE_TAG_FAILURE,
    CANCEL: types.CREATE_TAG_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
